<template>
  <div id="over_com">
    <img
      class="bang_tit imgBlock noevents-img"
      src="../../assets/guochao/bangtit.png"
    />
    <div class="ul_box">
      <img class="imgBlock noevents-img" src="../../assets/guochao/img00.png" />
      <div class="ctr_con relativeItem">
        <div class="se_con relativeItem">
          <div class="ss_icon absoluteItem">
            <img
              class="imgBlock noevents-img"
              src="../../assets/guochao/searicon.png"
            />
          </div>
          <input
            type="text"
            v-model="keyWord"
            placeholder="输入用户名称或朱贝号"
          />
          <div class="ss_btn absoluteItem" @click="searchFun">搜索</div>
        </div>

        <div class="lists_div">
          <div id="ulboxs" class="scroll_box">
            <ul class="ul_main flex-box">
              <li v-for="(n, i) in allDataList" :key="i">
                <img
                  class="imgBlock noevents-img"
                  src="../../assets/guochao/list01.png"
                />
                <div class="li_ctr">
                  <div
                    class="t_v_box relativeItem"
                    :style="{ height: tvHeight + 'px' }"
                    @click="playVideoFun(n)"
                  >
                    <img
                      class="imgBlock noevents-img"
                      :style="{ height: tvHeight + 'px' }"
                      :src="n.cover_image"
                    />
                    <div class="idx_con absoluteItem">{{ i + 1 }}</div>
                    <div class="play_con absoluteItem">
                      <img
                        class="imgBlock noevents-img"
                        src="../../assets/guochao/playicon.png"
                      />
                    </div>
                  </div>
                  <div class="bot_user_con flex-box">
                    <div class="avt_box">
                      <img
                        class="imgBlock noevents-img"
                        :src="n.avatar"
                        onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                      />
                    </div>
                    <div class="u_info">
                      <p class="apostrophe">{{ n.nick_name }}</p>
                      <p class="flex-box p2">
                        <i>朱贝号</i>
                        <i>{{ n.user_number }}</i>
                      </p>
                    </div>
                  </div>
                </div>
                <img
                  class="imgBlock noevents-img"
                  src="../../assets/guochao/list03.png"
                />
              </li>
              <div class="nonemore" v-show="noMore">
                &nbsp;&nbsp;没有更多了~&nbsp;&nbsp;
              </div>
            </ul>
          </div>
          <div class="no_data absoluteItem centerImg" v-show="noData">
            {{ noText }}
          </div>
        </div>
      </div>
      <img class="imgBlock noevents-img" src="../../assets/guochao/img02.png" />
    </div>
    <div class="vdo_tc" v-if="showVp">
      <video
        @click.stop
        id="video_yu"
        class="video_box"
        controls
        controlslist="nodownload"
        autoplay
        style="object-fit: fill"
        playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="allow"
        airplay="allow"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portrait"
        :src="videoSrc"
        :poster="coverImg"
      ></video>

      <div class="colse_btn flex-box" @click="clickTcVi">×</div>
    </div>
  </div>
</template>










<script>
export default {
  name: "over_com",
  data() {
    return {
      keyWord: "",
      allDataList: [],
      tvHeight: "127", //封面图的默认大小
      page: 1,
      noData: false, //空数据的展示
      noMore: false, //展示更多的
      list_more: true,
      noText: "暂无数据~",
      playsinline: false,
      showVp: false,
      videoSrc: "",
      coverImg: "",
    };
  },
  mounted() {
    this.getAllList("-1");
  },
  methods: {
    // 视频中X号的关闭
    clickTcVi() {
      this.showVp = false;
      this.$emit("changeBtn", false);
    },

    // video-player的播放结束
    onPlayerEnded() {
      this.showVp = false;
      this.$emit("changeBtn", false);
    },
    // 搜索按钮的点击
    searchFun() {
      this.noMore = false;
      document.querySelector(".ss_btn").classList.add("searBtn_ani");
      setTimeout(() => {
        document.querySelector(".ss_btn").classList.remove("searBtn_ani");
      }, 500);
      if (this.keyWord.trim() == "") {
        this.$tool.tip("请输入查询的内容~", "50%");
        return;
      }
      // 接下来的搜索操作
      this.page = 1;
      this.allDataList = [];
      this.getAllList(this.keyWord);
    },

    // 点击播放视频
    playVideoFun(n) {
      this.$emit("changeBtn", true);
      this.showVp = true;
      this.videoSrc = n.video;
      this.coverImg = n.cover_image;
      document.getElementById("video_yu").play();
    },

    // 获取所有的数据
    getAllList(val) {
      let _this = this;
      let data = {
        page: _this.page,
        pageSize: 20,
      };
      if (val != -1) {
        data.keywords = val;
        _this.noText = "未查询到此用户~";
      }
      this.$jsonp(this.$apis("gc_vote_list"), data, (res) => {
        let ls = res.data.data.data;
        if (ls.length > 0) {
          if (_this.page === 1) {
            _this.allDataList = ls;
            setTimeout(() => {
              _this.scroll_func();
            }, 500);
          } else {
            _this.allDataList = _this.allDataList.concat(ls);
          }
          setTimeout(() => {
            _this.tvHeight = document.querySelector(".t_v_box").offsetWidth;
          }, 300);
        } else {
          _this.list_more = false;
          if (data.page == 1) {
            _this.noData = true;
          } else {
            _this.noMore = true;
          }
        }
      });
    },

    //下拉加载更多 */
    scroll_func() {
      var _this = this;
      let item = document.querySelector("#ulboxs");
      let utop,
        sHeight,
        cheight = null;
      item.addEventListener("scroll", (e) => {
        (utop = e.target.scrollTop),
          (sHeight = e.target.scrollHeight),
          (cheight = e.target.clientHeight);
        if (sHeight - (utop + cheight) <= 20 && _this.list_more) {
          _this.page++;
          _this.getAllList();
        }
      });
    },
  },
  watch: {
    keyWord() {
      if (this.keyWord.trim() == "") {
        this.page = 1;
        this.allDataList = [];
        this.noData = false;
        this.noMore = false;
        this.list_more = true;
        this.noText = "暂无数据~";
        this.getAllList("-1");
      }
    },
  },
};
</script>









<style scoped>
.bang_tit {
  width: 80%;
  margin: auto;
}

.ul_box {
  margin-top: 6px;
}
.ctr_con {
  min-height: 430px;
  background: url("../../assets/guochao/img01.png") repeat;
  background-size: 100% 100%;
  padding: 0 10%;
}
.se_con {
  width: 100%;
  height: 34px;
  border: 1px solid #254254;
  border-radius: 20px;
  overflow: hidden;
  box-sizing: border-box;
}
.se_con input {
  width: 100%;
  height: 32px;
  padding-left: 12%;
  color: #71947f;
  font-size: 0.9375rem;
  background-color: #cbd9d1;
  box-sizing: border-box;
}
.se_con .ss_icon {
  left: 5%;
  top: 53%;
  transform: translateY(-50%);
}
.ss_icon img {
  width: 16px;
  height: 15px;
}
input::-webkit-input-placeholder {
  font-size: 0.75rem;
  color: #7a8c96;
  padding-bottom: 2px;
}
input:-moz-placeholder {
  font-size: 0.75rem;
  color: #7a8c96;
  padding-bottom: 2px;
}
input::-moz-placeholder {
  font-size: 0.75rem;
  color: #7a8c96;
  padding-bottom: 2px;
}
.ss_btn {
  top: 1px;
  right: 1px;
  width: 55px;
  height: 30px;
  line-height: 32px;
  text-align: center;
  border-radius: 20px;
  color: #fff;
  font-size: 0.75rem;
  border: 1px solid #254254;
  background: -webkit-linear-gradient(top, #2e9ecc, #1e597d);
  background: linear-gradient(to bottom, #2e9ecc, #1e597d);
}
.searBtn_ani {
  animation: bigBtnAni 0.2s linear;
}
/* 列表区域 */
.li_ctr {
  background: url("../../assets/guochao/list02.png") repeat;
  background-size: 100% 100%;
  padding: 0 6px;
}
.scroll_box {
  max-height: 600px;
  overflow-y: scroll;
}
.ul_main {
  flex-wrap: wrap;
}
.ul_main li {
  width: 49%;
  margin-right: 2%;
  margin-bottom: 3px;
}
.ul_main li:nth-child(2n) {
  margin-right: 0;
}
.lists_div {
  padding-top: 12px;
}
.t_v_box {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}
.t_v_box img {
  width: 100%;
}
.t_v_box .idx_con {
  top: 4px;
  left: 4px;
  background-color: rgba(37, 66, 84, 0.6);
  padding: 1px 6px;
  color: #fff;
  font-size: 0.75rem;
  border-radius: 5px;
}
.t_v_box .play_con {
  bottom: 4px;
  right: 4px;
}
.play_con img {
  width: 19px;
  height: 18px;
}
.avt_box {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
}
.avt_box img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}
.bot_user_con {
  align-items: center;
  padding: 8px 0 2px 2px;
}
.u_info {
  margin-left: 5px;
}
.u_info p:nth-child(1) {
  width: 80px;
  font-size: 0.875rem;
  color: #254254;
  font-weight: bold;
}
.u_info .p2 {
  align-items: center;
}
.u_info .p2 i {
  font-style: normal;
  color: #254254;
  padding-top: 2px;
}

.u_info .p2 i:nth-child(1) {
  font-size: 0.5rem;
}
.u_info .p2 i:nth-child(2) {
  padding-top: 3px;
  font-size: 0.5rem;
}
.nonemore {
  font-size: 0.6875rem;
  width: 100%;
  color: #254254;
  text-align: center;
  padding-top: 10px;
}
.no_data {
  font-size: 0.8125rem;
  color: #254254;
}
.vdo_tc {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
  background-color: rgba(0, 0, 0, 0.5);
}
.colse_btn {
  position: fixed;
  bottom: 8%;
  right: 8%;
  color: #fff;
  font-size: 1rem;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #fff;
}
/* #videoID {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
} */
#video_yu {
  width: 100vw;
  height: 100vh;
  z-index: 30;
}
</style>